import { Logout } from "@mui/icons-material";
import { Button } from "@mui/material";

const LogoutButton = ({
  handleLogout,
  isDrawerOpen,
  iconStyle,
  buttonStyle,
}) => {
  return (
    <Button
      aria-label="Logout"
      variant="text"
      startIcon={<Logout sx={iconStyle} />}
      onClick={handleLogout}
      sx={buttonStyle}
    >
      {isDrawerOpen ? "Logout" : ""}
    </Button>
  );
};

export default LogoutButton;
